/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ClientEvent, ClientEvents } from './client';
import { ServerEvent, ServerEvents } from './server';

/**
 * Typeguard for client events
 */
export function isClientEvent<EventType extends ClientEvents>(event: any): event is ClientEvent<EventType> {
  return Object.values(ClientEvents).includes(event.type as EventType);
}
export function isClientEventType<Event extends ClientEvents>(
  event: ClientEvent<ClientEvents>,
  eventType: Event,
): event is ClientEvent<Event> {
  return event.type === eventType;
}

/**
 * Typeguard for server events
 */
export function isServerEvent<EventType extends ServerEvents>(event: any): event is ServerEvent<EventType> {
  return Object.values(ServerEvents).includes(event.type as EventType);
}
export function isServerEventType<Event extends ServerEvents>(
  event: ServerEvent<ServerEvents>,
  eventType: Event,
): event is ServerEvent<Event> {
  return event.type === eventType;
}

/**
 * Parses the JSON and validates it against the respective class.
 * Will throw if it is malformed.
 *
 * @param message - Stringified JSON websocket message
 */
export async function parseMessage<
  ServerEventType extends ServerEvents,
  ClientEventType extends ClientEvents,
  Event extends ServerEvent<ServerEventType> | ClientEvent<ClientEventType>,
>(message: string): Promise<Event> {
  // Parse the stringified JSON
  let parsedMessage: Event;
  try {
    parsedMessage = JSON.parse(message);
  } catch (error) {
    throw new Error('Received malformed message');
  }

  return parsedMessage;
}
